import { render, staticRenderFns } from "./SearchTableBurgundy.vue?vue&type=template&id=1d9647cf&"
import script from "./SearchTableBurgundy.vue?vue&type=script&lang=js&"
export * from "./SearchTableBurgundy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports